import * as Types from '../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type DeleteInquiryMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type DeleteInquiryMutation = { __typename?: 'Mutation', adminDeleteInquiry: boolean };


export const DeleteInquiryDocument = gql`
    mutation deleteInquiry($id: UUID!) {
  adminDeleteInquiry(id: $id)
}
    `;
export type DeleteInquiryMutationFn = Apollo.MutationFunction<DeleteInquiryMutation, DeleteInquiryMutationVariables>;
export type DeleteInquiryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteInquiryMutation, DeleteInquiryMutationVariables>, 'mutation'>;

    export const DeleteInquiryComponent = (props: DeleteInquiryComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteInquiryMutation, DeleteInquiryMutationVariables> mutation={DeleteInquiryDocument} {...props} />
    );
    

/**
 * __useDeleteInquiryMutation__
 *
 * To run a mutation, you first call `useDeleteInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInquiryMutation, { data, loading, error }] = useDeleteInquiryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInquiryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInquiryMutation, DeleteInquiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInquiryMutation, DeleteInquiryMutationVariables>(DeleteInquiryDocument, options);
      }
export type DeleteInquiryMutationHookResult = ReturnType<typeof useDeleteInquiryMutation>;
export type DeleteInquiryMutationResult = Apollo.MutationResult<DeleteInquiryMutation>;
export type DeleteInquiryMutationOptions = Apollo.BaseMutationOptions<DeleteInquiryMutation, DeleteInquiryMutationVariables>;